module.exports = __webpack_public_path__ + "img/certificacao.e2688e55.svg";